import React, { useContext, useState } from 'react';
import { CustomerPortalProps } from './CustomerPortal';
import AppContext from '../contexts/AppContext';
import LoginContext from '../contexts/LoginContext';
import SearchShipmentsByReferenceContext from '../contexts/SearchShipmentsByReferenceContext';
import SearchShipmentsContext from '../contexts/SearchShipmentsContext';
import ViewProbillContext, { getDefaultProbillCallbacks } from '../contexts/ViewProbillContext';
import loadReferenceNumberSearchResults from '../utils/loadReferenceNumberSearchResults';
import SearchShipmentsByReferenceResultsContext from '../contexts/SearchShipmentsByReferenceResultsContext';

const SearchShipmentsByReference = (props: CustomerPortalProps) => {
    const context = useContext(SearchShipmentsByReferenceContext);
    const appContext = useContext(AppContext);
    const loginContext = useContext(LoginContext);
    const searchShipmentsByReferenceResultsContext = useContext(SearchShipmentsByReferenceResultsContext);
    const searchShipmentsContext = useContext(SearchShipmentsContext);
    const viewProbillContext = useContext(ViewProbillContext);

    const { query, errorMessage, updateQuery, updateErrorMessage } = context;
    const { updateCallbacks } = viewProbillContext;

    const [ submitting, setSubmitting ] = useState(false);

    const search = async (query: string) => {
        updateErrorMessage();
        
        const searchResults = await loadReferenceNumberSearchResults(props, searchShipmentsByReferenceResultsContext, appContext, loginContext, context, searchShipmentsContext, viewProbillContext, query);
        
        if (searchResults?.length === 1) {
            await updateCallbacks(getDefaultProbillCallbacks());

            props.history.push(`/probill/${encodeURIComponent(searchResults[0].probillNumber)}`);
        } else if (searchResults?.length === 0) {
            updateErrorMessage("No probill was found matching your search.");
        } else {
            props.history.push(`/search/reference?query=${encodeURIComponent(query)}`);
        }
    };

    return <React.Fragment>
        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
        <form className="form-inline" onSubmit={event => {
            (async () => {
                setSubmitting(true);

                try {
                    await search(query);
                } catch {}

                setSubmitting(false);
            })();

            event.stopPropagation();
            event.preventDefault();

            return false;
        }}>
            <fieldset disabled={submitting} style={{width: "300px"}}>
                <div className="input-group">
                    <input className="form-control" type="text" name="query" value={query} placeholder="Search by reference number" onChange={event => updateQuery(event.target.value)} required={true} maxLength={20} style={{height: "35px", width: "100%"}} />
                    <div className="input-group-append">
                        <button type="submit" className="btn btn-primary">Search</button>
                    </div>
                </div>
            </fieldset>
        </form>
    </React.Fragment>;
};

export default SearchShipmentsByReference;
